import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('fill_in_the_information'),
    sendButton: defineMessage('send'),
    greeting: defineMessage('dear_username'),
    chooseOption: defineMessage('choose_option'),
    mainMessage1: defineMessage('we_always_strive_to_imp_of_our_customer_service'),
    mainMessage2: defineMessage('to_help_us_provide_you___the_following_question'),
    question: defineMessage('how_many_organisations___created_in_approvalmax'),
    lessThanThree: defineMessage('less_than'),
    threeToTen: defineMessage('unknown_text_7'),
    moreThanTen: defineMessage('unknown_text_3'),
};
